export class Step6 {
    constructor() { }

    public getnboffresrecues = 'form.dive_at.getnboffresrecues';
    public getinformations = 'form.dive_at.getinformations';
    public getspan14 = 'form.dive_at.getspan14';

}
